import { useCallback } from 'react'
import { 
  // getCarAddress, 
  // getPokerAddress , 
  // getSushiAddress, 
  // getPetAddress,
  getPokerCardMasterContract, 
  getCarNFTMasterContract,
  carNFTMasterContractLockCAR
 } from '../../sushi/utils'
import { SUPPORTTYPE } from '../../constants/bakery/nft'

// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '..'

const useLockToken = (pokerCardId: string, type: string, tokenAmount: string, contractType?: string) => {
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  // 确认质押币   
  // const yam = useYam()
  // let tokenAddress = getPokerAddress(yam)
  let tokenContract = getPokerCardMasterContract(sushi)
  switch (type) {
    case SUPPORTTYPE.BAKE:
      // tokenAddress = getSushiAddress(yam)
      tokenContract = getPokerCardMasterContract(sushi)
      break
    case SUPPORTTYPE.PET:
      // tokenAddress = getPetAddress(yam)
      tokenContract = getPokerCardMasterContract(sushi)
      break
    case SUPPORTTYPE.POKER:
      // tokenAddress = getPokerAddress(yam)
      tokenContract = getPokerCardMasterContract(sushi)
      break
    case SUPPORTTYPE.CAR:
      // tokenAddress = getCarAddress(yam)
      tokenContract = getCarNFTMasterContract(sushi)
      break
  }
  const handleLockToken = useCallback(async () => {
    let txHash
    try {
      if(contractType === SUPPORTTYPE.CAR){
        txHash = await carNFTMasterContractLockCAR(
          tokenContract,
          pokerCardId,
          tokenAmount,
          account
        )
      }
      return txHash
    } catch (e) {
      return false
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [account, tokenContract, pokerCardId, tokenAmount, contractType])
  return { onLockToken: handleLockToken }
}

export default useLockToken
